<template>
  <div class="content">
    <!-- 全屏容器 -->
    <dv-full-screen-container>
      <div class="container">
       <!--  标头 -->
        <div class="a-MZN95-0">
        <!-- 跳转标签 -->
       

          <dv-decoration-10 style="width:34.5%;height:4px;position: absolute;top:61px" />
          <span class="title-text">大数据可视化平台</span>
          <dv-decoration-5 dur="6" style="width:600px;height:42px;margin:auto;" />"
          <dv-decoration-10
            style="width:34.5%;height:4px;transform: rotateY(180deg); position: absolute;
      right:0;top:61px;"
          />
          <!-- 装饰条 -->
          <div class="left-element">
    <!-- 您的左侧内容放在这里 -->
    
 <dv-decoration-3 style="width:800px;height:30px;" />
  </div>
  <div class="right-element">
     <dv-decoration-3 style="width:800px;height:30px;" />
  </div>
     <dv-border-box-2 :color="['white']" backgroundColor=#87CEFA style="width:160px;height:56px; margin-top:-100px; margin-left:20px;"><div class="tiao">首页</div></dv-border-box-2>
<dv-border-box-2 :color="['white']" backgroundColor=#87CEFA style="width:160px;height:56px; margin-top:-56px; margin-left:220px;"><div class="tiao">场站分析</div></dv-border-box-2>
<dv-border-box-2 :color="['white']" backgroundColor=#87CEFA style="width:160px;height:56px; margin-top:-56px; margin-left:410px;"><div class="tiao">系统监测</div></dv-border-box-2>
<dv-border-box-2 :color="['white']" backgroundColor=#87CEFA style="width:160px;height:56px; margin-top:-56px; margin-left:1310px;"><div class="tiao">数据分析</div></dv-border-box-2>
<dv-border-box-2 :color="['white']" backgroundColor=#87CEFA style="width:160px;height:56px; margin-top:-56px; margin-left:1500px;"><div class="tiao">用户数据</div></dv-border-box-2>

<div class="Timefont"><Time></Time></div>

        </div>
       
        <div class="a-MZN95-1">
           <dv-border-box-7 :color="['#02c5e92D']" backgroundColor=#87CEFA0D style="width:460px;height:970px;position: fixed;
left: 0;
bottom: 0;
"></dv-border-box-7>
          <div class="alltitle">&nbsp;&nbsp;服务次数&用户数据</div>
          <dv-border-box-7 :color="['#02c5e9']"  style="width:100px;height:120px;margin-top:56px; margin-left:40px;">
           <div class="hang">
            <p>总服务次数</p>
           <p>413000</p>
           <p>昨:1200</p>
            <p>+0.3%</p>
           </div>           
            </dv-border-box-7>
          <dv-border-box-7 :color="['#02c5e9']" style="width:100px;height:120px;margin-top:-120px; margin-left:190px;">
            <div class="hang">
            <p>总服务车主</p>
           <p>101800</p>
           <p>昨:10102</p>
            <p>+0.2%</p>
           </div> 
          </dv-border-box-7>
          <dv-border-box-7 :color="['#02c5e9']" style="width:100px;height:120px;margin-top:-120px; margin-left:340px;">
            <div class="hang">
            <p>总用户数量</p>
           <p>346500</p>
           <p>昨:4269</p>
            <p>+0.1%</p>
           </div> 
          </dv-border-box-7>
           <dv-border-box-7 :color="['#02c5e9']" style="width:100px;height:120px;margin-top:30px; margin-left:40px;">
            <div class="hang">
            <p>日活用户</p>
           <p>7721</p>
           <p>昨:2145</p>
            <p>+64%</p>
           </div> 
          </dv-border-box-7>
           <dv-border-box-7 :color="['#02c5e9']" style="width:100px;height:120px;margin-top:-120px; margin-left:190px;">
            <div class="hang">
            <p>新注册用户</p>
           <p>456</p>
           <p>昨:1345</p>
            <p>+72%</p>
           </div> 
          </dv-border-box-7>
        </div>
        <div class="a-z6Qnx-1">
          <dv-border-box-7 :color="['#02c5e94D']" backgroundColor=#87CEFA0D style="width:98%;height:99%;">
            <div class="boxhang">
 <body>
    <div class="box">
      <p>
6000&nbsp;

      </p>
      <p>kwh</p>
      <p>
今日发电量
      </p>
      </div>
            </body>
             
            <body>
    <div class="box">
      <p>
2000&nbsp;

      </p>
      <p>kwh</p>
      <p>
今日充电量
      </p>
      </div>
            </body>
             
            <body>
    <div class="box">
      <p>
128&nbsp;

      </p>
      <p>次</p>
      <p>
今日充电次
      </p>
      </div>
            </body>
            </div>
           
             <ChMap></ChMap>
          </dv-border-box-7>
         
        </div>
       <!--  右一 -->
        <div class="a-08E9X-1">
           <dv-border-box-7 :color="['#02c5e92D']" backgroundColor=#87CEFA0D style="width:480px;height:970px;position: fixed;
right: 0;
bottom: 0;
"></dv-border-box-7>
          <div class="alltitle">&nbsp;&nbsp;设备数据</div>
          <!-- 三个图表圆环 -->
          <div class="cicle">
            
           <Cicle> </Cicle>
          </div>
        </div>
       
        <!-- 右二 -->
        <div class="a-z6Qnx-2">
        <Table></Table>
        
        </div>
         <!-- 左二 -->
        <div class="a-Dq60J-0">
         <div class="alltitle">&nbsp;&nbsp;实时数据</div>
         <dv-scroll-board :config="config8" style="width:420px;height:600px;margin-top:56px; margin-left:30px;" />
        </div>
          <!-- 右三 -->
        <div class="a-Dq60J-2">
          <div class="alltitle">&nbsp;&nbsp;设备能耗</div>
        
          <GoldLIne></GoldLIne>
        </div>
        
         <!-- 中间图表 -->
        <div class="a-r2BYM-2-1">
          <dv-border-box-12 style="width:360px;height:42px" backgroundColor="#0000FF30">
            <div class="po">
              光伏 储能 充电 检测
            </div>            
            </dv-border-box-12>
            <div class="zhouqi">
              <p>今日</p>
              <p>按月</p>
              <p>按年</p>
            </div>
          <charts></charts>
        </div>
 <!-- 右四 -->
        <div class="a-08E9X-2">
          <div class="alltitle">&nbsp;&nbsp;设备工单</div>
      <dv-scroll-board :config="config7" style="width:420px;height:250px;margin-top:56px; margin-left:30px;" />
          </div>
      </div>
      <div class="as">afa</div>
    </dv-full-screen-container>
  </div>
</template>
 
<script>
import ChMap from "./ChMap.vue";
import Time from "./ChTime.vue";
import Cicle from "./chartLint.vue";
import Table from "./TableLow.vue";
import GoldLIne from "./chartGoldLIne.vue";
import charts from "./multiple-charts.vue";
import {config7,config8} from "./config.js"
export default {
  name: "HomeView",

  components: {
    ChMap,
    Time,
    Cicle,
    Table,
    GoldLIne,
    charts
    
  },
  data() {
    
    return {
      config1: {
        data: [
          {
            name: "南阳",
            value: 167,
          },
          {
            name: "周口",
            value: 67,
          },
          {
            name: "漯河",
            value: 123,
          },
          {
            name: "郑州",
            value: 55,
          },
          {
            name: "西峡",
            value: 98,
          },
        ],
      },
      config2: {
        data: [
          {
            name: "周口",
            value: 55,
          },
          {
            name: "南阳",
            value: 120,
          },
          {
            name: "西峡",
            value: 71,
          },
          {
            name: "驻马店",
            value: 66,
          },
          {
            name: "新乡",
            value: 80,
          },
          {
            name: "信阳",
            value: 35,
          },
          {
            name: "漯河",
            value: 15,
          },
        ],
        img: [
          "http://datav.jiaminghi.com/img/conicalColumnChart/1st.png",
          "http://datav.jiaminghi.com/img/conicalColumnChart/2st.png",
          "http://datav.jiaminghi.com/img/conicalColumnChart/3st.png",
          "http://datav.jiaminghi.com/img/conicalColumnChart/4st.png",
          "http://datav.jiaminghi.com/img/conicalColumnChart/5st.png",
          "http://datav.jiaminghi.com/img/conicalColumnChart/6st.png",
          "http://datav.jiaminghi.com/img/conicalColumnChart/7st.png",
        ],
      },
      config7,
      config8,
      config3: {
        data: [
          ["行1列1", "行1列2", "行1列3"],
          ["行2列1", "行2列2", "行2列3"],
          ["行3列1", "行3列2", "行3列3"],
          ["行4列1", "行4列2", "行4列3"],
          ["行5列1", "行5列2", "行5列3"],
          ["行6列1", "行6列2", "行6列3"],
          ["行7列1", "行7列2", "行7列3"],
          ["行8列1", "行8列2", "行8列3"],
          ["行9列1", "行9列2", "行9列3"],
          ["行10列1", "行10列2", "行10列3"],
        ],
      },
      config4: {
        points: [
          {
            name: "郑州",
            coordinate: [0.48, 0.35],
          },
          {
            name: "新乡",
            coordinate: [0.52, 0.23],
          },
          {
            name: "焦作",
            coordinate: [0.43, 0.29],
          },
          {
            name: "开封",
            coordinate: [0.59, 0.35],
          },
          {
            name: "许昌",
            coordinate: [0.53, 0.47],
          },
          {
            name: "平顶山",
            coordinate: [0.45, 0.54],
          },
          {
            name: "洛阳",
            coordinate: [0.36, 0.38],
          },
          {
            name: "周口",
            coordinate: [0.62, 0.55],
          },
          {
            name: "漯河",
            coordinate: [0.56, 0.56],
          },
          {
            name: "南阳",
            coordinate: [0.37, 0.66],
          },
          {
            name: "信阳",
            coordinate: [0.55, 0.81],
          },
          {
            name: "驻马店",
            coordinate: [0.55, 0.67],
          },
          {
            name: "济源",
            coordinate: [0.37, 0.29],
          },
          {
            name: "三门峡",
            coordinate: [0.2, 0.36],
          },
          {
            name: "商丘",
            coordinate: [0.76, 0.41],
          },
          {
            name: "鹤壁",
            coordinate: [0.59, 0.18],
          },
          {
            name: "濮阳",
            coordinate: [0.68, 0.17],
          },
          {
            name: "安阳",
            coordinate: [0.59, 0.1],
          },
        ],
        lines: [
          {
            source: "新乡",
            target: "郑州",
          },
          {
            source: "焦作",
            target: "郑州",
          },
          {
            source: "开封",
            target: "郑州",
          },
          {
            source: "许昌",
            target: "郑州",
          },
          {
            source: "平顶山",
            target: "郑州",
          },
          {
            source: "洛阳",
            target: "郑州",
          },
          {
            source: "周口",
            target: "郑州",
          },
          {
            source: "漯河",
            target: "郑州",
          },
          {
            source: "南阳",
            target: "郑州",
          },
          {
            source: "信阳",
            target: "郑州",
          },
          {
            source: "驻马店",
            target: "郑州",
          },
          {
            source: "济源",
            target: "郑州",
          },
          {
            source: "三门峡",
            target: "郑州",
          },
          {
            source: "商丘",
            target: "郑州",
          },
          {
            source: "鹤壁",
            target: "郑州",
          },
          {
            source: "濮阳",
            target: "郑州",
          },
          {
            source: "安阳",
            target: "郑州",
          },
        ],

        bgImgSrc: require("../img/map.jpg"),
      },
      config5: {
        data: [
          {
            name: "周口",
            value: 55,
          },
          {
            name: "南阳",
            value: 120,
          },
          {
            name: "西峡",
            value: 78,
          },
          {
            name: "驻马店",
            value: 66,
          },
          {
            name: "新乡",
            value: 80,
          },
          {
            name: "信阳",
            value: 45,
          },
          {
            name: "漯河",
            value: 29,
          },
        ],
      },
      config6:{
      data: [
    {
      name: '周口',
      value: 55
    },
    {
      name: '南阳',
      value: 120
    }
  
  ],
  lineWidth: 10
      },
      
    };
   
  },
};
</script>
 
<style>
</style>
